import Call from '../Call';
import {objToQs} from '../Utils';

const PushapiFactor = {
    get(filters) {
        return Call(`pushapiFactor?${objToQs(filters)}`);
    },

    getAll(filters) {
        return Call(`pushapiFactor/all?${objToQs(filters)}`);
    },

    getAffid() {
        return Call(`pushapiFactor/affid`);
    },

    getSubids() {
        return Call(`pushapiFactor/subid`);
    }
}

export default PushapiFactor;


// WEBPACK FOOTER //
// ./src/services/API/components/PushapiFactor.js